import { render, staticRenderFns } from "./topping.vue?vue&type=template&id=1ae00a1c&scoped=true&"
import script from "./topping.vue?vue&type=script&lang=js&"
export * from "./topping.vue?vue&type=script&lang=js&"
import style0 from "./topping.vue?vue&type=style&index=0&id=1ae00a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae00a1c",
  null
  
)

export default component.exports